<template>
  <path d="M9 16L9 3.83L14.59 9.42L16 8L8 -3.49691e-07L-3.49691e-07 8L1.41 9.41L7 3.83L7 16L9 16Z" fill="#178F7E"></path>
</template>

<script>
    export default {
        name: 'icon-arrow-up'
    }
</script>